const PRODUCT_PREVIEW_MAX_LENGTH = 140;

function capitalizeFirstLetter(value: string): string {
    if (!value) {
        return value;
    }

    return value.charAt(0).toUpperCase() + value.slice(1);
}

export function buildProductPreviewText(params: {
    text: string | null | undefined;
    productNames: Array<string | null | undefined>;
    maxLength?: number;
}): string {
    const {
        text,
        productNames,
        maxLength = PRODUCT_PREVIEW_MAX_LENGTH,
    } = params;
    const originalText = text?.trim() ?? "";

    if (!originalText) {
        return "";
    }

    const names = productNames
        .map((name) => name?.trim())
        .filter((name): name is string => Boolean(name))
        .sort((a, b) => b.length - a.length);

    let preview = originalText;
    const lowerPreview = preview.toLowerCase();
    const matchingName = names.find((name) =>
        lowerPreview.startsWith(name.toLowerCase()),
    );

    if (matchingName) {
        preview = preview
            .slice(matchingName.length)
            .replace(/^[\s:;,.()[\]{}'"“”‘’\-–—]+/, "")
            .replace(/^is\s+/i, "")
            .trim();
    }

    return capitalizeFirstLetter((preview || originalText).slice(0, maxLength));
}
